import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import Toolbar from '@material-ui/core/Toolbar';
import PromocodeList from '../../components/Customer/PromocodeList.jsx';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import HolidayList from '../../components/Customer/HolidayList.jsx';


const styles = theme => ({
    card: {
        color: theme.palette.secondary.main
    }
});
const sendProps = props => {
    const { classes, ...rest } = props;
    return rest;
};
export class Holiday extends Component {
    render() {
        const { classes } = this.props;
        return (
            <div className="tz-2-com tz-2-main">
                <h4>
                    Holidays
                </h4>

                <div className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <HolidayList {...sendProps(this.props)} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const composedAddress = compose(withStyles(styles));
export default composedAddress(Holiday);



// WEBPACK FOOTER //
// ./src/views/User/Holiday.jsx